import {
  EQUIPMENT,
  EXERCISE_TYPE,
  loadExercisesAction,
  MUSCLE,
  updateEquipmentFilterExercisesAction,
  updateMuscleFilterExercisesAction,
  updateQueryExercisesUiAction,
  updateTypeFilterExercisesAction
} from '@gymaholic/packages'
import getLocationRouterSelect from 'modules/router/selectors/get-location'

const queryString = require('query-string')

export function syncUrlWithReduxExerciseAction () {
  return (dispatch, getState) => {
    const location = getLocationRouterSelect(getState())
    const search = queryString.parse(location.search)

    if (search.q !== undefined) {
      dispatch(updateQueryExercisesUiAction(search.q))
    }

    if (
      search.muscles !== undefined &&
      search.muscles
    ) {
      const musclesArr = search.muscles.split(',')
      const muscleIds = []
      if (musclesArr) {
        musclesArr.map((muscle) => {
          muscleIds.push(MUSCLE[muscle.toUpperCase().replace(/ /g, '_')])
          return null
        })
        dispatch(updateMuscleFilterExercisesAction(muscleIds))
      }
    }

    if (
      search.equipment !== undefined &&
      search.equipment
    ) {
      const equipmentsArr = search.equipment.split(',')
      const equipmentIds = []
      if (equipmentsArr) {
        equipmentsArr.map((equipment) => {
          equipmentIds.push(EQUIPMENT[equipment.toUpperCase().replace(/ /g, '_')])
          return null
        })
        dispatch(updateEquipmentFilterExercisesAction(equipmentIds))
      }
    }

    let typesArr
    let typesIds
    if (
      search.types !== undefined &&
      search.types
    ) {
      typesArr = search.types.split(',')
      typesIds = []
    }
    if (typesArr) {
      typesArr.map((type) => {
        typesIds.push(EXERCISE_TYPE[type.toUpperCase().replace(/ /g, '_')])
        return null
      })
      dispatch(updateTypeFilterExercisesAction(typesIds))
    }

    dispatch(
      loadExercisesAction({
        shouldUseFilters: true,
        shouldExcludeIds: true
      })
    )
  }
}
